import PropTypes from 'prop-types';
import './styles/cardGridStyles.css';

const CardGridTemplate = ({ children, maxCardWidth, minCardWidth }) => {
  const cardColumn = {
    gridTemplateColumns: `repeat(auto-fill, minmax(${minCardWidth}, ${maxCardWidth}))`,
  };

  return (
    <div
      className="card-grid-template grid gap-4 grid-rows-1"
      style={cardColumn}
    >
      {children}
    </div>
  );
};

/* Defaults from design team */
CardGridTemplate.defaultProps = {
  maxCardWidth: '1fr',
  minCardWidth: '18rem',
};

CardGridTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  maxCardWidth: PropTypes.string,
  minCardWidth: PropTypes.string,
};

export default CardGridTemplate;
